export function buildOrgFields(orgInfo: any): any {
	return {
		orgId: orgInfo.orgId,
	};
}
